// extracted by mini-css-extract-plugin
module.exports = {"hidden":"chip_hidden__0eHi_","textEmphasis":"chip_textEmphasis__qsMg0","chip":"chip_chip__GyMe8","btnDelete":"chip_btnDelete__qWSxK"};